const locationSchema = {
  '$id': '/location',
  title: 'Location',
  type: 'object',
  properties: {
    id: { 'type': 'string', 'readOnly': true },
    name: { 'type': 'string', minLength: 2, maxLength: 255 },
    address_one: { type: 'string', maxLength: 255 },
    address_two: { type: 'string', maxLength: 255 },
    age: { type: 'number', 'readOnly': true },
    city: { type: 'string', maxLength: 255 },
    cloud: { type: 'boolean' },
    compliances: { type: 'array', 'readOnly': true },
    config: { type: 'object', 'readOnly': true },
    country: { type: 'string' },
    created: { 'type': 'string', 'readOnly': true },
    created_by: { 'type': 'string', 'format': 'uuid', 'readOnly': true },
    deleted: { 'type': 'string', 'readOnly': true  },
    deleted_by: { 'type': 'string', 'format': 'uuid', 'readOnly': true },
    fax: { type: 'string', maxLength: 20 },
    mobile: { type: 'string', maxLength: 20 },
    modified: { type: 'string', 'readOnly': true },
    modified_by: { type: 'string', 'readOnly': true },
    notes: { type: 'string' },
    orgId: { type: 'string' },
    person_count: { type: 'number', 'readOnly': true },
    persons: { type: 'array', 'readOnly': true },
    phone: { type: 'string', maxLength: 20 },
    postal: { type: 'string', maxLength: 10 },
    state: { type: 'string', maxLength: 255 },
    timezone: { type: 'string' }
  },
  'required': [
    'name',
    'city',
    'country',
    'timezone'
  ],
  'additionalProperties': false
}

export default locationSchema
